/** Форма расходной накладной — UI 1:1 с Excel «Складской учет 20». */
import { DocumentForm } from "@/components/warehouse/DocumentForm";

export function WarehouseOutflowFormPage() {
  return <DocumentForm direction="outflow" />;
}
